export enum LocalizationRequester {
  IPhone = 1,
  IPad = 2,
  Android = 3,
  WebSite = 4,
  MonitoringWebSite = 5,
  ProtectedUserWebSite = 6,
  WebAlertAnswer = 7
}